



































































import { Component, Vue } from 'vue-property-decorator';
import * as amplitude from 'amplitude-js';
import {
  ItemDTO, CatalogItemShortDTO, CompilationLookDTO,
} from '@/api';
import EditingLayout from '@/layouts/EditingLayout.vue';
import VImage from '@/components/common/VImage.vue';
import {
  clientsModule, compilationsModule, thingsModule,
} from '@/store';
import LooksItem from '@/components/looks/LooksItem.vue';
import CheckCard from '@/components/common/CheckCard.vue';
import LookActionsCard from '@/components/looks/LookActionsCard.vue';
// import { Route } from 'vue-router';
import { getAssetUrl } from '@/utils';

@Component({
  name: 'compilation-looks-edit-page',
  components: {
    EditingLayout,
    LooksItem,
    LookActionsCard,
    VImage,
    CheckCard,
  },
})
export default class Catalog extends Vue {
  get client() {
    return clientsModule.model;
  }

  get compilation() {
    return compilationsModule.model;
  }

  get looks() {
    return compilationsModule.groupedThingsByLook;
  }

  get look() {
    return this.looks.find(look => look.id === Number(this.$route.query.selected));
  }

  get things() {
    return compilationsModule.things.filter(thing => !thing.clientItemId || thing.inWardrobe);
  }

  get lookThings() {
    const ids = this.look ? this.look.thingIds : [];
    return compilationsModule.things.filter(look => ids?.includes(look.id as number));
  }

  get selectedThings() {
    return this.lookThings.map(thing => thing.id);
  }

  get selectedClientThings() {
    return this.lookThings.map(thing => thing.clientItemId);
  }

  get categories() {
    return thingsModule.categories;
  }

  get groupByCategory() {
    return thingsModule.groupByCategory;
  }

  get loadingThing() {
    return thingsModule.loadingList;
  }

  created() {
    amplitude.getInstance().logEvent('Страница редактирование луков в подборке', { clientId: this.client && this.client.id });
    const { compilationId, clientId } = this.$route.params;
    compilationsModule
      .fetchCompilation({ compilationId: Number(compilationId) })
      .then((compilation) => {
        const lookId = (compilation.looks || [])[0]?.id;
        if (lookId && !this.$route.query.selected) {
          this.selectLook(lookId);
        }
      });
    clientsModule.fetchStylists();

    thingsModule.fetchThings(Number(clientId));
  }

  selectLook(id: number) {
    if (id !== Number(this.$route.query.selected)) {
      this.$router.push({ query: { selected: String(id) } });
    }
  }

  scrollIntoView(id: number) {
    if (Array.isArray(this.$refs.actionCards)) {
      const element = this.$refs.actionCards[this.looks.findIndex(look => look.id === id)];
      if (!(element instanceof Element)) {
        element.$el.scrollIntoView({ block: 'center' });
      }
    }
  }

  async addLook() {
    if (this.compilation?.id != null) {
      const id = await compilationsModule.createLook(this.compilation.id);
      this.selectLook(id);
    }
  }

  async copyLook(look: CompilationLookDTO) {
    if (this.compilation?.id != null && look.id != null) {
      const id = await compilationsModule
        .copyLook({ compilationId: this.compilation?.id, compilationLookId: look.id });
      if (id) {
        this.selectLook(id);
        this.scrollIntoView(id);
      }
    }
  }

  removeLook(compilationLookId: number) {
    this.$confirm('Вы уверены, что хотите удалить данный образ?', 'Внимание!', {
      confirmButtonText: 'Удалить',
      cancelButtonText: 'Отмена',
      type: 'warning',
    }).then(() => {
      if (this.compilation?.id != null) {
        compilationsModule.deleteLook({ compilationId: this.compilation.id, compilationLookId });
      }
      this.$message({
        type: 'success',
        message: 'Образ удалён',
      });
    });
  }

  addThingToLook(thingId: number) {
    if (this.compilation?.id && this.look?.id && !this.loadingThing) {
      compilationsModule.addThingToLook({
        compilationId: this.compilation.id,
        compilationLookId: this.look.id,
        thingId,
      });
    }
  }

  addClientThingToLook(clientThingId: number) {
    if (this.compilation?.id && this.look?.id && !this.loadingThing) {
      compilationsModule.addClientThingToLook({
        compilationId: this.compilation.id,
        compilationLookId: this.look.id,
        clientThingId,
      });
    }
  }

  removeLookThing(thingId: number) {
    if (this.compilation?.id && this.look?.id != null) {
      compilationsModule.deleteThingFromLook({
        compilationId: this.compilation.id,
        compilationLookId: this.look.id,
        thingId,
      });
    }
  }

  removeClientLookThing(clientThingId: number) {
    if (this.compilation?.id && this.look?.id != null) {
      compilationsModule
        .deleteClientThingFromLook({
          compilationId: this.compilation.id,
          compilationLookId: this.look.id,
          clientThingId,
        });
    }
  }

  isThingSelected(id: number) {
    return this.selectedThings.includes(id);
  }

  isClientThingSelected(id: number) {
    return this.selectedClientThings.includes(id);
  }

  thingImg(item: ItemDTO & CatalogItemShortDTO) {
    if (item.pictUrl) {
      return getAssetUrl(item.pictUrl);
    }
    return item.fileNames && item.fileNames.length ? item.fileNames[0].fileName : null;
  }
}
